import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export default function SendToOrg({ formik }) {
    const navigate = useNavigate();
    const [summary, setSummary] = useState()

    useEffect(() => {
        getAssessmentSummary()
    }, [])

    const getAssessmentSummary = () => {
        axios.post(`/api/getAssessmentSummary`, {assessmentId: formik.values.id, questions: formik.values.questions, subjects: formik.values.subjects})
        .then(function (response) {
            let result = response.data;
            if(result.success){
                setSummary(result.data)
            }
        })
    }

    const sendToOrg = () => {
        Swal.fire({
            title: 'Are you sure you want to send the assessment to admin?',
            showCancelButton: true,
            confirmButtonColor: '#45a7c4',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, send it!',
            cancelButtonText: 'No'
          }).then((result) => {
            if (result.isConfirmed) { 
                axios.post("/api/sendToOrg", {assessmentId: formik.values.id}).then(res => {
                    if(res.data.success){
                        Swal.fire(res.data.message, '', 'success')
                    } 
                    else{
                        Swal.fire(res.data.message, '', 'error')
                    }
                }).catch((error) => {
                    Swal.fire("Something went wrong", '', 'error')
                });
            } else if (result.isDenied) {
                Swal.fire('Cancelled!', '', 'info')
            }
        }) 
        
    }

    const sendToSubjectsRaters = () => {
        Swal.fire({
            title: 'Are you sure you want to send the assessment to all subjects and raters?',
            showCancelButton: true,
            confirmButtonColor: '#45a7c4',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, send it!',
            cancelButtonText: 'No'
          }).then((result) => {
            if (result.isConfirmed) { 
                axios.post("/api/sendToSubjectsRaters", {assessmentId: formik.values.id}).then(res => {
                    if(res.data.success){
                        Swal.fire(res.data.message, '', 'success')
                        navigate('/assessments')
                    } 
                    else{
                        Swal.fire(res.data.message, '', 'error')
                    }
                }).catch((error) => {
                    Swal.fire("Something went wrong", '', 'error')
                });
            } else if (result.isDenied) {
                Swal.fire('Cancelled!', '', 'info')
            }
        }) 
        
    }

    return (
        <div className="row py-4">
            <div className="col-md-8 offset-md-2 mt-4">
                <div className="row">
                    <div className="col-md-4">
                        <h3 className="heading fs_20 mb-4">Send Assessment</h3>
                    </div>
                    <div className="col-md-8 text-end">
                        <button className="btn send_btn text-white me-2" onClick={sendToOrg}>Save and Send to Admin</button>
                        <button className="btn send_btn text-white" onClick={sendToSubjectsRaters}>Send to Subjects/Raters</button>
                    </div>
                </div>
                <div className="mb-4">
                    <div className="mb-3 d-flex align-items-center">
                        <label className="form-label fs_15 fw-semibold mb-0">Subject:</label>
                        <div className="ms-2">
                            <p className="mb-0 fw-semibold">
                                {summary?.subjects}
                            </p>
                        </div>
                    </div>
                    <div className="mb-3 d-flex align-items-center">
                        <label className="form-label fs_15 fw-semibold mb-0">Rater Group:</label>
                        <div className="ms-2">
                            <p className="mb-0 fw-semibold">
                                {summary?.raterGroups}
                            </p>
                        </div>
                    </div>
                    <div className="mb-3 d-flex align-items-center">
                        <label className="form-label fs_15 fw-semibold mb-0">Survey Template:</label>
                        <div className="ms-2">
                            <p className="mb-0 fw-semibold">
                                {formik.values.survey?.name}
                            </p>
                        </div>
                    </div>
                    <div className="mb-3 d-flex align-items-center">
                        <label className="form-label fs_15 fw-semibold mb-0">Competencies:</label>
                        <div className="ms-2">
                            <p className="mb-0 fw-semibold">
                                {summary?.competencies}
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="mb-3 d-flex align-items-center">
                                <label className="form-label fs_15 fw-semibold mb-0">No. of Opinion Scale Questions:</label>
                                <div className="ms-2">
                                    <p className="mb-0 fw-semibold sendassessment">
                                        {summary?.no_of_opinion_scale_questions}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-3 d-flex align-items-center">
                                <label className="form-label fs_15 fw-semibold mb-0">No. of Open Ended Feedback Questions:</label>
                                <div className="ms-2">
                                    <p className="mb-0 fw-semibold sendassessment">
                                    {summary?.no_of_open_ended_questions}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table className="table sendAssessmentable">
                        <tr>
                            <th>Rater Group</th>
                            <th>No. of Raters</th>
                        </tr>
                        {
                            summary?.raters && Object.keys(summary.raters).map((key) => {
                                return (
                                    <tr>
                                        <td>{key}</td>
                                        <td>{summary.raters[key]}</td>
                                    </tr>
                                )
                            })
                        }
                    </table>
                </div>
                
                {/* <div className="py-3">
                    <div className="d-flex align-items-center">
                        <p className="fw-semibold fs_16 mb-0">Conformation Status: </p>
                        <div class="fw-semibold d-flex align-items-center ms-3">
                            <span class="px-2 py-1 border border-success border-1 text-success rounded">Approved</span>
                        </div>
                        <div class="fw-semibold d-flex align-items-center ms-3">
                            <span class="px-2 py-1 border border-warning border-1 text-warning rounded">Pending</span>
                        </div>
                    </div>
                </div> */}
            </div>
        </div>
    )

}